// Mirrors service/lib/mlsAgreements/constants.js (Contracts, overview.md); keys below are camelCase to match API responses.
export const AGREEMENT_STATUSES = ['active', 'pending', 'expired', 'terminated', 'cancelled'];
export const AGREEMENT_TYPES = ['IDX', 'Brokerage', 'VOW'];
export const COMPLIANCE_RULE_KEYS = ['vow_permitted'];
/** Display labels for the rule keys — a raw key never reaches the screen. */
export const COMPLIANCE_RULE_LABELS: Record<string, string> = { vow_permitted: 'VOW permitted' };

export const CREDENTIAL_TYPES = ['IDX', 'BROKERAGE'];
export const FEE_CYCLES = ['monthly', 'quarterly', 'annual', 'one_time'];
export const FEE_BASES = ['vendor', 'per_agent'];
export const MLS_DATA_TYPES = ['IDX', 'VOW', 'BBO'];
export const MLS_PROTOCOLS = ['WebAPI', 'RETS'];
export const MLS_VENDORS = ['Trestle', 'Spark', 'Custom', 'Direct'];
export const DOC_TYPES = ['agreement', 'contract', 'other'];

export const EXPIRING_GROUP_TITLES = {
  d7: 'Within 7 days',
  d30: 'Within 30 days',
  d90: 'Within 90 days',
  lapsed: 'Lapsed',
  noExpiration: 'No expiration set',
};
